import React, { useContext, useEffect, useState } from "react";
import SummaryApi from "../common";
import Context from "../context";
import displayINRCurrency from "../helpers/displayCurrency";
import { MdDelete } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import emptyCart from "../assest/empty-cart.json"


const Cart = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [warranty, setWarranty] = useState("none");

  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const context = useContext(Context);

  const [showAuthDrawer, setShowAuthDrawer] = useState(false);

  const getDeliveryDate = () => {
    const start = new Date();
    const end = new Date();

    start.setDate(start.getDate() + 5);
    end.setDate(end.getDate() + 6);

    const options = { weekday: "short", month: "short", day:"numeric"};

    return `${start.toLocaleDateString("en-IN", options)} - ${end.toLocaleDateString("en-IN", options)}`;
  };

  const handleCheckout = () => {
    if (user?._id) {
      navigate("/checkout");
    } else {
      setShowAuthDrawer(true);
    }
  };

  const fetchData = async () => {
    setLoading(true);

    const response = await fetch(
      SummaryApi.addToCartProductView.url,
      {
        method: SummaryApi.addToCartProductView.method,
        credentials: "include",
        headers: { "content-type": "application/json" },
      }
    );

    const responseData = await response.json();

    if (responseData.success) {
      setData(responseData.data);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const updateQty = async (id, quantity) => {
    if (quantity < 1) return;

    const response = await fetch(SummaryApi.updateCartProduct.url, {
      method: SummaryApi.updateCartProduct.method,
      credentials: "include",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ _id: id, quantity }),
    });

    const responseData = await response.json();
    if (responseData.success) fetchData();
  };

  const deleteCartProduct = async (id) => {
    const response = await fetch(SummaryApi.deleteCartProduct.url, {
      method: SummaryApi.deleteCartProduct.method,
      credentials: "include",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ _id: id }),
    });

    const responseData = await response.json();

    if (responseData.success) {
      fetchData();
      context.fetchUserAddToCart();
    }
  };

  const totalQty = data.reduce((sum, item) => sum + item.quantity, 0);

  // const subtotal = data.reduce(
  //   (sum, item) =>
  //     sum + item.quantity * item?.productId?.sellingPrice,
  //   0
  // );

const subtotal = data.reduce(
  (sum, item) => 
    sum + item.quantity * item.price,
  0
);


  const warrantyCost =
    warranty === "6m"
      ? subtotal * 0.05
      : warranty === "1y"
      ? subtotal * 0.1
      : 0;

  const finalTotal = subtotal + warrantyCost;

  if (!loading && data.length === 0) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">

      <div className="w-[300px]">
        <Lottie animationData={emptyCart} loop={true} />
      </div>

      <h2 className="text-xl font-semibold mt-4">
        Your cart is empty 🛒
      </h2>

      <p className="text-gray-500 mt-2 text-center">
        Looks like you haven't added anything yet
      </p>

      <button
        onClick={() => navigate("/")}
        className="mt-5 bg-black text-white px-6 py-2 rounded-full hover:opacity-90"
      >
        Continue Shopping
      </button>

    </div>
  );
}

  return (
    // ONLY UI PART UPDATED (logic same rakha hai)

  <div className="bg-[#f5f5f5] min-h-screen py-6">
    <div className="max-w-7xl mx-auto px-4">

      {/* HEADER */}
      <h1 className="text-2xl font-semibold mb-4">
        Cart ({totalQty} items)
      </h1>

      <div className="flex flex-col lg:flex-row gap-6">

        {/* LEFT SECTION */}
        <div className="flex-1 space-y-4">

          {/* SHIPPING BOX */}
          <div className="bg-white p-4 rounded-lg border flex items-center gap-4">
            <div className="bg-blue-100 p-3 rounded-full">🚚</div>
            <div>
              <p className="font-medium">
                Shipping, arrives {getDeliveryDate()}
              </p>
              <p className="text-sm text-gray-500">95829</p>
            </div>
          </div>

          {/* ITEMS */}
          {data.map((product) => (
            <div
              key={product._id}
              className="bg-white p-4 rounded-lg border flex flex-col md:flex-row gap-4"
            >
              {/* IMAGE */}
              <img
                src={product?.productId?.productImage[0]}
                className="w-28 h-28 object-contain"
              />

              {/* DETAILS */}
              <div className="flex-1">
                <h2 className="font-medium text-sm md:text-base">
                  {product?.productId?.productName}
                </h2>

                <p className="text-xs text-gray-500 mt-1">
                  {product.ram} / {product.storage}
                </p>

                <p className="text-xs text-gray-500">
                  Color: Black
                </p>

                {/* ACTIONS */}
                <div className="flex items-center gap-4 mt-3 text-sm">
                  <button
                    onClick={() => deleteCartProduct(product._id)}
                    className="text-blue-600"
                  >
                    Remove
                  </button>
                  <button className="text-blue-600">
                    Save for later
                  </button>
                </div>
              </div>

              {/* PRICE + QTY */}
              <div className="flex flex-col items-end justify-between">
                <p className="text-green-600 font-semibold">
                  {displayINRCurrency(product.price)}
                </p>

                {/* QTY */}
                <div className="flex items-center border rounded-full px-3 py-1 mt-2">
                  <button
                    onClick={() =>
                      updateQty(product._id, product.quantity - 1)
                    }
                  >
                    -
                  </button>
                  <span className="px-3">{product.quantity}</span>
                  <button
                    onClick={() =>
                      updateQty(product._id, product.quantity + 1)
                    }
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* RIGHT SECTION */}
        {data.length > 0 && (
          <div className="w-full lg:w-[350px]">
            <div className="bg-white p-5 rounded-lg border sticky top-20">

              {/* CHECKOUT BTN */}
              <button
                onClick={handleCheckout}
                className="w-full bg-blue-600 text-white py-2 rounded-full font-medium"
              >
                Continue to checkout
              </button>

              {/* SAVINGS */}
              <div className="bg-blue-50 text-sm p-3 rounded mt-3 flex justify-between">
                <span>Items price reduced</span>
                <span className="text-blue-600 font-medium">
                  Save ₹{Math.round(subtotal * 0.1)}
                </span>
              </div>

              {/* SUMMARY */}
              <div className="mt-4 text-sm space-y-2">
                <div className="flex justify-between">
                  <span>Subtotal ({totalQty} items)</span>
                  <span className="line-through text-gray-400">
                    ₹{subtotal + 150}
                  </span>
                </div>

                <div className="flex justify-between text-green-600">
                  <span>Savings</span>
                  <span>-₹{Math.round(subtotal * 0.1)}</span>
                </div>

                <div className="flex justify-between">
                  <span>Taxes</span>
                  <span className="text-gray-500">
                    Calculated at checkout
                  </span>
                </div>
              </div>

              {/* TOTAL */}
              <div className="flex justify-between font-semibold text-lg mt-4 border-t pt-3">
                <span>Estimated total</span>
                <span>{displayINRCurrency(subtotal)}</span>
              </div>

              {/* GIFT OPTION */}
              <div className="mt-3 text-sm">
                <input type="checkbox" /> This order is a gift
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>



  );
};

export default Cart;